import { isMobile } from "is-mobile";

const audioExt = window.webkitAudioContext ? '.mp3' : '.ogg' 

export default {
  trucks: [
    {
      name: 'F4',
      model: './models/f4/Textures.glb',
      image: './truck-images/f4.png',
      freestyle_door: './models/f4/freestyledoor.glb',
      freestyle_model: './models/f4/freestyle.glb',
      hidden_meshes: ['Vacuum', 'WashGun', 'WashGun001', 'Flow_(1)'],
      hidden_freestyle: ['Truck3', 'TruckDoor'],
      shown_freestyle: ['WashGun001', 'Flow_(1)'],
      constants: {
        remoteHoldDuration: 1000,
      },
    },
    {
      name: 'F3',
      model: 'www.somewhere.com',
      image: './truck-images/truckF3_t.png',
      disabled: true,
    },
    {
      name: 'F5',
      model: 'www.somewhere.com',
      image: './truck-images/truckF5_t.png',
      disabled: true,
    },
      {
      name: 'T70',
      model: 'www.somewhere.com',
      image: './truck-images/truckT70_t.png',
      disabled: true,
    },
  ],
  simulations: [
    {
      truck: 'F4',
      
      list: [
        // ANCHOR Boom Position
        {
          clipName: 'BoomRise',
          sound: ['./simulations/sounds/sim1and2boom.mp3', './simulations/sounds/sim1and2boom.mp3'],
          manual: {
            lever: 'LeverMesh6',
            label: 'Label3',
            clipName: 'Lever6Pull',
            timeout: 5000,
          },
          name: 'boom position',
          descr: 'boom position raising & lowering',
          id: 'boomPos',
          actionspeed: 1 / 4.9,
          campos: {
            LEVERS_COMPLETE: {
              camera:[-1070.2872995114967, 405.74854866418525, -195.55943408910122],
              controls: [-11.009311166759492, 150, -213.2172535469850]
            },
            FREESTYLE: {
              camera:[-1070.2872995114967, 405.74854866418525, -195.55943408910122],
              controls: [-11.009311166759492, 150, -213.2172535469850]
            },
            REMOTE_SIMULATION: {
              camera:[-1070.2872995114967, 405.74854866418525, -195.55943408910122],
              controls: [-11.009311166759492, 150, -213.2172535469850]
            },
            MANUAL_SIMULATION: {
              camera:[-172.04810292979664, 159.11503274533868, -575.5414406782497],
              controls: [-87.54183516529231, 150, -573.8786153341988]
            },
          },
          title: 'BOOM POSITION',
          subTitle: 'raising & lowering',
          images: ['./slider/boom-position.png'],
          remote: {
            lights: ['WhiteBTn1', 'WhiteBTn2']
          },
          firstPosSimType: 'REMOTE_SIMULATION',
          dialogs: {
            REMOTE_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: `To raise the boom press and hold the highlighted <b> BOOM UP </b> button on the remote. Hold the button down for <b> 5 seconds </b> to raise the boom 42°. Press the down button to lower the boom. `
                      },
                    ]
                  }
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'BOOM ROTATION',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ],
            MANUAL_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: `To raise the boom pull the leaver towards you and hold for <b> 5 seconds </b> to raise the boom 42°. Pushing the leaver away from you will lower the boom.`
                      },
                    ]
                  }
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'BOOM ROTATION',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ]
          }
        },
        // ANCHOR Boom Rotation
        {
          name: 'boom rotation',
          descr: 'left & right',
          clipName: 'BoomRotate',
          sound: ['./simulations/sounds/sim1and2boom.mp3', './simulations/sounds/sim1and2boom.mp3'],
          manual: {
            lever: 'LeverMesh5',
            label: 'Label4',
            clipName: 'Lever5Pull',
            timeout: 5000
          },
          id: 'boomRot',
          images: [')'],
          actionspeed: 1 / 1.8,
          campos: {
            LEVERS_COMPLETE: {
              camera: [80.16268770500298, 301.52059664243745, -1720.7303483796693],
              controls: [0, 150, 0]
            },
            FREESTYLE: {
              camera: [80.16268770500298, 301.52059664243745, -1720.7303483796693],
              controls: [0, 150, 0]
            },
            REMOTE_SIMULATION: {
              camera: [80.16268770500298, 301.52059664243745, -1720.7303483796693],
              controls: [0, 150, 0]
            },
            MANUAL_SIMULATION: {
              camera:[-172.04810292979664, 159.11503274533868, -575.5414406782497],
              controls: [-87.54183516529231, 150, -573.8786153341988]
            },
          },
          title: 'BOOM ROTATION',
          subTitle: 'left & right',
          remote: {
            lights: ['WhiteBTn4', 'WhiteBTn3'],
            reverse: true
          },
          firstPosSimType: 'REMOTE_SIMULATION',
          dialogs: {
            REMOTE_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` Rotate the boom into position by pressing the <b> BOOM RIGHT </b> button on the remote. Hold the button down for <b> 5 seconds </b> to rotate the boom 90° right. Pressing the left button will rotate the boom left. `
                      },
                    ]
                  }
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'BOOM REACH',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              },
            ],
            MANUAL_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: ` Rotate the boom right by pulling the leaver <b> towards </b> you and holding for <b> 5 seconds </b>. To rotate the boom left, push the leaver <b> away </b> from you. `
                  },
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'BOOM REACH',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ]
          }
        },
        // ANCHOR Boom Reach
        {
          clipName: 'BoomReach',
          sound: ['./simulations/sounds/sim3-extend.mp3', './simulations/sounds/boom3-back.mp3'],
          manual: {
            lever: 'LeverMesh4',
            label: 'Label5',
            clipName: 'Lever4Pull',
            timeout: 5000
          },
          name: 'boom reach',
          actionspeed: 1 / 3,
          descr: 'extending & retracting',
          id: 'boomReach',
          images: [')'],
          campos: {
            LEVERS_COMPLETE: {
              camera: [80.16268770500298, 301.52059664243745, -1720.7303483796693],
              controls: [0, 150, 0]
            },
            FREESTYLE: {
              camera: [80.16268770500298, 301.52059664243745, -1720.7303483796693],
              controls: [0, 150, 0]
            },
            REMOTE_SIMULATION: {
              camera: [80.16268770500298, 301.52059664243745, -1720.7303483796693],
              controls: [0, 150, 0]
            },
            MANUAL_SIMULATION: {
              camera:[-172.04810292979664, 159.11503274533868, -575.5414406782497],
              controls: [-87.54183516529231, 150, -573.8786153341988]
            },
          },
          title: 'BOOM EXTENSION',
          subTitle: 'extending & retracting',
          remote: {
            reverse: true,
            lights: ['WhiteBTn6', 'WhiteBtn5'],
            afterComplete: ['WhiteBtn5'],
          },
          firstPosSimType: 'REMOTE_SIMULATION',
          dialogs: {
            REMOTE_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` Extend the boom reach by pressing the <b> BOOM OUT </b> button on the remote. Pressing the <b> BOOM IN </b> button will retract the boom reach. `
                      },
                    ]
                  }
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'VACUUM',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              },
            ],
            MANUAL_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: ` To extend the boom reach, pull the leaver towards you and hold for <b> 5 seconds </b>. Pushing the leaver away from you will retract the boom reach. `
                  },
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'VACUUM',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ]
          }
        },
        // ANCHOR Vacuum
        {
          name: 'vacuum',
          descr: 'on & off',
          id: 'vacuum',
          images: [')'],
          shown_meshes: ['Vacuum'],
          campos: {
            LEVERS_COMPLETE: {
              camera: [-739.039547032439, 357.14655414085234, -1358.8696918673566],
              controls: [0, 150, 0]
            },
            FREESTYLE: {
              camera: [-739.039547032439, 357.14655414085234, -1358.8696918673566],
              controls: [0, 150, 0]
            },
            REMOTE_SIMULATION: {
              camera: [-739.039547032439, 357.14655414085234, -1358.8696918673566],
              controls: [0, 150, 0]
            },
            MANUAL_SIMULATION: {
              camera:[-172.04810292979664, 159.11503274533868, -575.5414406782497],
              controls: [-87.54183516529231, 150, -573.8786153341988]
            },
          },
          clipName: '',
          sound: [`./simulations/sounds/sim4vacuum${audioExt}`, `./simulations/sounds/sim4vacuum${audioExt}`],
          nativeAnimation: {
            name: 'VacuumNative',
            meshName: 'Vacuum',
          },
          clipNameStatic: 'BoomVacuum',
          manual: {
            lever: 'LeverMesh3',
            reverse: true,
            label: 'Label6',
            clipName: 'Lever3Push'
          },
          title: 'VACUUM',
          subTitle: 'on & off',
          remote: {
            type: 'toggler',
            lights: ['WhiteBTn7', 'WhiteBTn8'],
          },
          firstPosSimType: 'REMOTE_SIMULATION',
          dialogs: {
            REMOTE_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` Turn the vacuum on by pressing the highlighted <b> VACUUM ON </b> button on the remote. Press the <b> VACUUM OFF </b> button (right side), to turn the vacuum off. `
                      },
                    ]
                  }
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'WATER',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ],
            MANUAL_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: ` Turn the vacuum on by pushing the leaver <b> AWAY </b> from you and releasing. Pulling the leaver towards you and releasing will turn the vacuum off. `
                  },
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'WATER',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ]
          }
        },
        // ANCHOR Watter
        {
          name: 'Watter',
          descr: 'ON / OFF & Pressure',
          id: 'watterPreure',
          clipName: '',
          sound: [`./simulations/sounds/sim5and10${audioExt}`],
          manual: {
            lever: 'empty',
            label: 'empty',
            clipName: 'empty'
          },
          shown_meshes: ['WashGun', 'Flow'],
          isSeparated: true,
          images: [')'],
          clipNameStatic: "VanBodyDoorOpen",
          additionalCamPos: !isMobile() ?
            {
              camera: [-104.79639461123551, 195.60711749797233, 81.430818913645],
              controls: [-74.526448258637, 150, 610.1007287091015]
            } 
            :
            {
              camera:  [-99.34007173767151, 195.60711749797173, 87.35703599736644],
              controls: [-61.27620987423338, 150, 615.5230000610868]
            }
          ,
          nativeAnimation: {
            name: 'WaterLvl0Native',
            meshName: 'Flow',
          },
          controlBox: {
            steps: [
              {
                meshName: 'WaterPumpReset_button',
                type: 'click',
                clipName: 'WaterResetSwitchPress',
                light: 'SwitchEm2'
              },
              {
                meshName: 'WaterPumpBypass_button',
                type: 'click',
                clipName: 'WaterMumpBypassPress',
                light: 'SwitchEm3'
              },
              {
                meshName: 'WaterPumpManual_button',
                clipName: 'WaterMumpManualPress',
                type: 'click',
                light: 'SwitchEm1'
              },
              {
                clipName: 'KnobRotate',
                type: 'waterTrack',
                meshName: 'Knob_Rotate'
              },
              {
                meshName: 'WaterPumpBypass_button',
                type: 'click',
                clipName: 'WaterMumpBypassPress',
                light: 'SwitchEm3'
              },
            ]
          },
          addCamposTimeout: 1,
          campos: {
            LEVERS_COMPLETE: {
              camera: [0, 0, 0],
              controls: [0, 0, 0],
            },
            
            FREESTYLE: {
              camera: [-1110.460947188538, 357.4150199319814, -35.007239965235556],
              controls: [-81.02689329831202, 150, -326.6123042581434]
            },
            REMOTE_SIMULATION: {
              camera: [-1110.460947188538, 357.4150199319814, -35.007239965235556],
              controls: [-81.02689329831202, 150, -326.6123042581434]
            },
            MANUAL_SIMULATION: {
              camera: [-338.23824460005983, 167.88226010095732, 81.43989587223737],
              controls: [748.4811754003969, 150, 162.1251007803845],
            }
          },
          title: 'WATER',
          subTitle: 'ON / OFF & Pressure Set',
          hideToggler: true,
          secondaryWait: true,
          firstPosSimType: 'MANUAL_SIMULATION',
          loopSound: true,
          remote: {
            lights: ['WhiteBTn9', 'WhiteBTn10'],
            type: 'toggler',
            endOnStop: true,
          },
          dialogs: {
            MANUAL_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                  // NOTE Step: 1
                  {                    
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: `To set the water pressure, press the <b> WATER PUMP RESET </b> button. This will reset the water pump mode. `
                      },
                    ]
                  },
                  // NOTE Step: 2
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` Press the <b> WATTER PUMP BYPASS </b> button. `
                      },
                    ]
                  },
                  // NOTE Step: 3
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` Press the <b> WATER PUMP MANUAL  </b>  button. This will enable you to set the water pressure with the 1-9 dial. `
                      },
                    ]
                  },
                  // NOTE Step: 4
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` Rotate the dial to set the desired water pressure, up to a maximum pressure of 2800 PSI`
                      },
                    ]
                  },
                  // NOTE Step: 5
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` Now Switch <b> WATER PUMP BYPASS </b> from <b> ON </b> to <b> OFF </b>. This will enable the Remote to turn the <b> WATER PUMP ON </b> and  OFF <b/> at the preset pressure `
                      },
                    ]
                  },
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'DOOR LATCH',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ],
            REMOTE_SIMULATION: [
              {
                "type": "GUIDE_DIALOG",
                "steps": [
                  {
                    // NOTE Step: 6
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` To turn the water on, press the <b> WATER ON </b> button. `                        
                      },
                    ]
                  },
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` To turn the water off, press the <b> WATER OFF </b> button. `
                      },
                    ]
                  },
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'DOOR LATCH',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                    
                  },
                ]
              }
            ]
          }, 
        },
        // ANCHOR  Door Latch
        {
          name: 'door latch',
          clipName: 'DoorLatch',
          sound: ['./simulations/sounds/sim6door-lock.mp3', './simulations/sounds/sim6door-lock.mp3'],
          manual: {
            lever: 'LeverMesh8',
            label: 'Label1',
            clipName: 'Lever8Pull'
          },
          remote: {
            type: 'toggler',
            lights: ['WhiteBTn1', 'WhiteBTn2'],
            greenButton: true,
          },
          descr: 'lock & unlock',
          id: 'doorLatch',
          actionspeed: 1,
          images: [')'],
          campos: {
            LEVERS_COMPLETE: {
              camera: [23.604223050008965, 220.85066984055325, -1144.7849977990886],
              controls: [0, 150, 0]
            },
            FREESTYLE: {
              camera: [23.604223050008965, 220.85066984055325, -1144.7849977990886],
              controls: [0, 150, 0]
            },
            REMOTE_SIMULATION: {
              camera: [23.604223050008965, 220.85066984055325, -1144.7849977990886],
              controls: [0, 150, 0]
            },
            MANUAL_SIMULATION: {
              camera:[-172.04810292979664, 159.11503274533868, -575.5414406782497],
              controls: [-87.54183516529231, 150, -573.8786153341988]
            },
          },
          title: 'DOOR LATCH',
          subTitle: 'lock & unlock',
          
          firstPosSimType: 'REMOTE_SIMULATION',
          dialogs: {
            REMOTE_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                  {
                    content: [
                      {                        
                        type: 'CONTENT_TEXT',
                        title: 'HOW TO ACTIVATE THE SECONDARY FUNCTION',
                        value: ` Pressing down the <b> green </b> button causes the secondary function indicator light to pulse. Continue holding the button to remain in the secondary functions mode. `
                      },
                    ]
                  },
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` To unlock the door latch press the highlighted <b> DOOR LATCH UNLOCK </b> button on the remote. Press the <b> LOCK </b> (right side button) to lock the door latch. `
                      },
                    ]
                  }
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'DOOR OPEN & CLOSE',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ],
            MANUAL_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: ` Pressing down the <b> green </b> button causes the secondary function indicator light to pulse. Continue holding the button to remain in the secondary functions mode. `
                  },
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'DOOR OPEN & CLOSE',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ]
          }
        },
        // ANCHOR Door Open And Close
        {
          name: 'door',
          descr: 'open & close',
          id: 'doorEve',
          images: [')'],
          clipName: 'DoorOpen',
          actionspeed: 1 / 3.5,
          campos: {
            LEVERS_COMPLETE: {
              camera: [23.604223050008965, 220.85066984055325, -1144.7849977990886],
              controls: [0, 150, 0]
            },
            FREESTYLE: {
              camera: [23.604223050008965, 220.85066984055325, -1144.7849977990886],
              controls: [0, 150, 0]
            },
            REMOTE_SIMULATION: {
              camera: [23.604223050008965, 220.85066984055325, -1144.7849977990886],
              controls: [0, 150, 0]
            },
            MANUAL_SIMULATION: {
              camera:[-172.04810292979664, 159.11503274533868, -575.5414406782497],
              controls: [-87.54183516529231, 150, -573.8786153341988]
            },
          },
          title: 'DOOR',
          subTitle: 'open & close',
          sound: ['./simulations/sounds/sim7door-opening.mp3', './simulations/sounds/sim7door-closing.mp3'],
          manual: {
            lever: 'LeverMesh7',
            label: 'Label2',
            clipName: 'Lever7Pull',
            timeout: 5000
          },
          remote: {
            lights: ['WhiteBTn3', 'WhiteBTn4'],
            greenButton: true
          },
          firstPosSimType: 'REMOTE_SIMULATION',
          dialogs: {
            REMOTE_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                  {
                    content: [
                      {                        
                        type: 'CONTENT_TEXT',
                        title: 'HOW TO ACTIVATE THE SECONDARY FUNCTION',
                        value: ` Pressing down the <b> green </b> button causes the secondary function indicator light to pulse. Continue holding the button to remain in the secondary functions mode. `
                      },
                    ]
                  },
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` To open the door, press and hold dowh the <b> DOOR OPEN </b> button on the remote for <b> 5 seconds </b> . This opens the door by 90° `
                      },
                    ]
                  }
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'MUD SWEEP',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ],
            MANUAL_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: ` To open the door, pull the leaver towards you and hold for <b> 5 seconds </b>. To close the door, push the leaver forward and hold untill the door is closed. `
                  },
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'MUD SWEEP',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ]
          }
        },
        // ANCHOR Mud Sweep
        {
          name: 'mud sweep',
          descr: 'descend & incline',
          clipName: 'MudSweep',
          sound: ['./simulations/sounds/sim8mud.mp3', './simulations/sounds/sim8mud.mp3'],
          manual: {
            lever: 'LeverMesh2',
            label: 'Label7',
            clipName: 'Lever2Pull',
            timeout: 5000
          },
          id: 'mudSweep',
          actionspeed: 1 / 7,
          images: [')'],
          campos: {
            LEVERS_COMPLETE: {
              camera: [23.604223050008965, 220.85066984055325, -1144.7849977990886],
              controls: [0, 150, 0]
            },
            FREESTYLE: {
              camera: [23.604223050008965, 220.85066984055325, -1144.7849977990886],
              controls: [0, 150, 0]
            },
            REMOTE_SIMULATION: {
              camera: [23.604223050008965, 220.85066984055325, -1144.7849977990886],
              controls: [0, 150, 0]
            },
            MANUAL_SIMULATION: {
              camera: [-172.04810292979664, 159.11503274533868, -575.5414406782497],
              controls: [-87.54183516529231, 150, -573.8786153341988]
            },
          },
          title: 'mud sweep',
          clipNameStatic: 'DoorOpenStatic',
          subTitle: 'descend & incline',
          remote: {
            greenButton: true,
            reverse: true,
            lights: ['WhiteBtn5', 'WhiteBTn6'],
          },
          firstPosSimType: 'REMOTE_SIMULATION',
          dialogs: {
            REMOTE_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                  {
                    content: [
                      {                        
                        type: 'CONTENT_TEXT',
                        title: 'HOW TO ACTIVATE THE SECONDARY FUNCTION',
                        value: ` Pressing down the <b> green </b> button causes the secondary function indicator light to pulse. Continue holding the button to remain in the secondary functions mode. `
                      },
                    ]
                  },
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` Now, press down the <b> MUD SWEEP OUT </b> button on the remote for <b> 5 seconds </b>. This opens the door 90°. `
                      },
                    ]
                  }
                ]
              },
              {
                type: 'END_DIALOG',
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: 'Well done. Next up is the'
                      },
                      {
                        type: 'CONTENT_BUTTON',
                        value: 'VACUUM',
                        action: 'BUTTON_NEXT_SIMULATION'
                      },
                      {
                        type: 'CONTENT_TEXT',
                        value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                      },
                    ]
              }
            ],
            MANUAL_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: ` Now, press down the <b> MUD SWEEP OUT </b> button on the remote for <b> 5 seconds </b>. This opens the door 90°. `
                  },
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'ENGINE',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ]
          }
        },
        // ANCHOR Engine
        {
          name: 'engine',
          descr: 'resume & set',
          clipName: '',
          sound: [
            `./simulations/sounds/sim91${audioExt}`,
            `./simulations/sounds/sim92${audioExt}`,
            `./simulations/sounds/sim93${audioExt}`,
            `./simulations/sounds/sim94${audioExt}`,
            `./simulations/sounds/sim95${audioExt}`,
            `./simulations/sounds/sim96${audioExt}`,
            `./simulations/sounds/sim97${audioExt}`,
          ],
          manual: {
            lever: 'empty',
            label: 'empty',
            clipName: 'empty'
          },
          counter: {
            type: 'engine',
            min: 0,
            max: 6,
            duration: 5000,
          },
          clipNameStatic: "VanBodyDoorOpen",

          additionalCamPos: !isMobile() ?
            {
              camera: [-104.79639461123551, 195.60711749797233, 81.430818913645],
              controls: [-74.526448258637, 150, 610.1007287091015]
            } 
            :
            {
              camera:  [-99.34007173767151, 195.60711749797173, 87.35703599736644],
              controls: [-61.27620987423338, 150, 615.5230000610868]
            }
          ,
          controlBox: {
            steps: [
              {
                meshName: 'EngineControl_button',
                type: 'click',
                clipName: 'EngineControlPress',
                light: 'SwitchEm5'
              },
              {
                meshName: 'EngineIncrease_button',
                type: 'switch',
                clipName: 'EngineIncreasePress',
                light: 'SwitchEm4'
              },
            ]
          },
          id: 'engine',
          images: [')'],
          addCamposTimeout: 1,
          campos: {
            LEVERS_COMPLETE: {
              camera: [0, 0, 0],
              controls: [0, 0, 0],
            },
            FREESTYLE: {
              camera: [-1001.9051709827936, 261.38156185451845, 77.59129639487207],
              controls: [246.99586677143682, 150, -131.40093733116473]
            },
            REMOTE_SIMULATION: {
              camera: [-1001.9051709827936, 261.38156185451845, 77.59129639487207],
              controls: [246.99586677143682, 150, -131.40093733116473]
            },
            MANUAL_SIMULATION: {
              camera: [-338.23824460005983, 167.88226010095732, 81.43989587223737],
              controls: [748.4811754003969, 150, 162.1251007803845],
            } 
          },
          title: 'engine',
          subTitle: 'resume & set',
          remote: {
            lights: ['WhiteBTn7', 'WhiteBTn8'],
            greenButton: true,
            reverse: true,
            type: 'toggler'
          },
          firstPosSimType: 'REMOTE_SIMULATION',
          dialogs: {
            REMOTE_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                  {
                    content: [
                      {                        
                        type: 'CONTENT_TEXT',
                        title: 'HOW TO ACTIVATE THE SECONDARY FUNCTION',
                        value: ` Pressing down the <b> green </b> button causes the secondary function indicator light to pulse. Continue holding the button to remain in the secondary functions mode. `
                      },
                    ]
                  },
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` Pressing the <b> ENGINE SET </b> button increases the engine RPM. Pressing the <b> RESUME </b> button will return the engine RPM to the manually set default. `
                      },
                    ]
                  }
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'WATER PRESSURE',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ],
            MANUAL_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                    {
                      content: [
                        {
                          type: 'CONTENT_TEXT',
                          value: ` Press the <b> ENGINE CONTROL </b> button to activate the Engine Control function. `
                        },
                      ]
                    },
                    {
                      content: [
                        {
                          type: 'CONTENT_TEXT',
                          value: ` Press the <b> ENGINE INCREASE </b> button to increase the Engines RPM. Pressing the <b> DECRASE </b> button lowers the Engine RPM. `
                        },
                      ]
                    }
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'WATER PRESSURE',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ]
          }
        },// ANCHOR Watter Presure
        {
          name: 'water pressure',
          descr: 'ON / OFF & PRESSURE SET',
          clipName: '',
          manual: {
            lever: 'empty',
            label: 'empty',
            clipName: 'empty'
          },
          id: 'watterPresure',
          isSeparated: true,
          images: [')'],
          campos: {
            LEVERS_COMPLETE: {
              camera: [0, 0, 0],
              controls: [0, 0, 0],
            },
            FREESTYLE: {
              camera: [-1110.460947188538, 357.4150199319814, -35.007239965235556],
              controls: [-81.02689329831202, 150, -326.6123042581434]
            },
            REMOTE_SIMULATION: {
              camera: [-1110.460947188538, 357.4150199319814, -35.007239965235556],
              controls: [-81.02689329831202, 150, -326.6123042581434]
            },
            MANUAL_SIMULATION: {
              camera: [-338.23824460005983, 167.88226010095732, 81.43989587223737],
              controls: [748.4811754003969, 150, 162.1251007803845],
            }
          },
          clipNameStatic: "VanBodyDoorOpen",
          loopSound: true,
          additionalCamPos: !isMobile() ?
            {
              camera: [-104.79639461123551, 195.60711749797233, 81.430818913645],
              controls: [-74.526448258637, 150, 610.1007287091015]
            } 
            :
            {
              camera:  [-99.34007173767151, 195.60711749797173, 87.35703599736644],
              controls: [-61.27620987423338, 150, 615.5230000610868]
            }
          ,
          controlBox: {
            steps: [
              {
                meshName: 'WaterPumpReset_button',
                type: 'click',
                clipName: 'WaterResetSwitchPress',
                light: 'SwitchEm2'
              },
              {
                meshName: 'WaterPumpManual_button',
                clipName: 'WaterMumpManualPress',
                type: 'click',
                light: 'SwitchEm007'
              },
            ]
          },
          shown_meshes: ['WashGun'],
          addCamposTimeout: 1,
          title: 'water pressure',
          hideMesh: 'Flow',
          subTitle: 'dec / inc',
          sound: [
            `./simulations/sounds/sim5and10${audioExt}`,
            `./simulations/sounds/sim102${audioExt}`,
            `./simulations/sounds/sim103${audioExt}`,
          ],
          remote: {
            lights: ['Plane001', 'Plane002'],
            greenButton: true,
            noGreenButton: true,
            type: 'toggler',
          },
          counterSteps: [
            {
              isFirst: true,
              steps: [
                {
                  nativeAnimation: {
                    name: 'WaterLvl1Native',
                    meshName: 'Flow'
                  },
                  target: {
                    type: 'remote',
                    target: 'WhiteBTn9'
                  },
                  sound: `./simulations/sounds/sim5and10${audioExt}`
                }
              ]
            },
            {
              steps: [
                {
                  target: {
                    type: 'remote',
                    target: 'greenButton'
                  },
                }
              ]
            },
            {
              steps: [
                {
                  nativeAnimation: {
                    name: 'WaterLvl2Native',
                    meshName: 'Flow'
                  },
                  target: {
                    type: 'remote',
                    target: 'WhiteBTn10',
                  },
                  sound: `./simulations/sounds/sim102${audioExt}`
                },
                {
                  nativeAnimation: {
                    name: 'WaterLvl3Native',
                    meshName: 'Flow'
                  },
                  target: {
                    type: 'remote',
                    target: 'WhiteBTn10',
                  },
                  sound: `./simulations/sounds/sim103${audioExt}`
                },
              ]
            },
            {
              steps: [
                {
                  nativeAnimation: {
                    name: 'WaterLvl2Native',
                    meshName: 'Flow'
                  },
                  target: {
                    type: 'remote',
                    target: 'WhiteBTn9',
                  },
                  sound: `./simulations/sounds/sim102${audioExt}`
                },
                {
                  nativeAnimation: {
                    name: 'WaterLvl1Native',
                    meshName: 'Flow'
                  },
                  target: {
                    type: 'remote',
                    target: 'WhiteBTn9',
                  },
                  sound: `./simulations/sounds/sim5and10${audioExt}`
                },
              ]
            },
            {
              steps: [
                {
                  target: {
                    type: 'remote',
                    target: 'greenButton'
                  },
                }
              ]
            },
            {
              isLast: true,
              steps: [
                {
                  target: {
                    type: 'remote',
                    target: 'WhiteBTn10'
                  },
                  stopAnimations: true
                }
              ]
            },
          ],
          // counter: {
          //   type: 'preasure',
          //   min: 0,
          //   max: 3,
          //   duration: 5000,
          // },
          hideToggler: true,
          firstPosSimType: 'MANUAL_SIMULATION',
          dialogs: {
            MANUAL_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` To set water preasure, press the  <b> WATER PUMP RESET </b> button. This will reset the water pump mode `
                      },
                    ],
                  },
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` Press the <b> WATER PUMP REMOTE</b> button. `
                      },
                    ],
                  },
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'BOOM REACH',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ],
            REMOTE_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                steps: [
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` To turn the water on, press the <b> WATER ON </b> button. `
                      },
                    ]
                  },
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: ` To increase the water pressure, press and hold the green button to activate the Secondary Function.`
                      },
                    ]
                  },
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: `Press the <b> WATER PRESSURE INCREASE </b> button multiple times (2) to reach the maximum water pressure. (The number of presses to reach the maximum pressure will depend on your truck specifications)`
                      },
                    ]
                  },
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: `To lower the water pressure, press the <b> WATER PRESSURE DECREASE </b> button 2 times. (The number of presses needed will vary depending on your truck specifications)`
                      },
                    ]
                  },
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: `To shut the water off, release the green button (by clicking it). Doing this will return you to the primary function.`
                      },
                    ]
                  },
                  {
                    content: [
                      {
                        type: 'CONTENT_TEXT',
                        value: `To shut the water off, press the <b> WATER OFF </b> button.`,
                      },
                    ]
                  },
                ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: 'Well done. Next up is the'
                  },
                  {
                    type: 'CONTENT_BUTTON',
                    value: 'SLUDGE PUMP',
                    action: 'BUTTON_NEXT_SIMULATION'
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              },
            ],
            
          }
        },
        // ANCHOR Sludge Pump
        {
          name: 'sludge pump',
          clipName: '',
          sound: [],
          manual: {
            lever: 'LeverMesh1',
            label: 'Label8',
            clipName: 'Lever1Pull'
          },
          descr: 'off load',
          id: 'sludgePump',
          images: [')'],
          noAVPS: true,
          campos: {
            LEVERS_COMPLETE: {
              camera:[-172.04810292979664, 159.11503274533868, -575.5414406782497],
              controls: [-87.54183516529231, 150, -573.8786153341988]
            },
            FREESTYLE: {
              camera:[-1070.2872995114967, 405.74854866418525, -195.55943408910122],
              controls: [-11.009311166759492, 150, -213.2172535469850]
            },
            REMOTE_SIMULATION: {
              camera:[-1070.2872995114967, 405.74854866418525, -195.55943408910122],
              controls: [-11.009311166759492, 150, -213.2172535469850]
            },
            MANUAL_SIMULATION: {
              camera:[-172.04810292979664, 159.11503274533868, -575.5414406782497],
              controls: [-87.54183516529231, 150, -573.8786153341988]
            },
          },
          title: 'SLUDGE PUMP',
          subTitle: 'off load',
          remote: {
            lights: ['Plane001', 'Plane002']
          },
          firstPosSimType: 'MANUAL_SIMULATION',
          dialogs: {
            MANUAL_SIMULATION: [
              {
                type: 'GUIDE_DIALOG',
                  content: [
                    {
                      type: 'CONTENT_TEXT',
                      value: ` To offload the contents of the tank pull the leaver <b> TOWARDS </b> you. Releasing the leaver will cause it to remain in the position you placed it in. To close the Sludge Pump, push the leaver away from you. `
                    },
                  ]
              },
              {
                type: 'END_DIALOG',
                content: [
                  {
                    type: 'CONTENT_TEXT',
                    value: ` Great job! 
                    You completed all simulations. `
                  },
                  {
                    type: 'CONTENT_TEXT',
                    value: 'You can also select the simulation from the menu <div class="icon_menu icon"> </div>'
                  },
                ]
              }
            ]
          }
        },
      ],
      freestyle: {
        content: {
          title: 'F-4 ECO-LITE SIMULATOR',
          text: `
            <p> To begin, select the green on button. Then select the grey button corresponding to the desired truck function. </p>
            <p> To begin a secondary function, hold down the green button. Then select the grey button to activate functions labeled in green. To reset the remote, select the red off button.</p>
          `
        },
        list: [
          {
            id: 'boompos',
            campos: {
              camera:[-1485.0539836097382, 394.7875247106073, -518.6429115704836],
              controls: [-17.85989274689098, 150, -249.0564813616552]
            },
            actions: [
              {
                buttons: [
                  {
                    name: 'WhiteBTn1',
                    dir: 1,
                    syncSound: true,
                    sound: './simulations/sounds/sim1and2boom.mp3',
                  },
                  {
                    name: 'WhiteBTn2',
                    dir: -1,
                    syncSound: true,
                    sound: './simulations/sounds/sim1and2boom.mp3',
                  },
                ],
                clipName: 'FreestyleRise',
                type: 'hold',
                actionspeed: 1 / 2,
              }
            ],
            content: [
              {
                title: 'BOOM POSITION',
                subtitle: 'RAISING & LOWERING',
                text: 
                  `<p>To raise the boom, press and hold the highlighted <b>BOOM UP</b>  button. Once raised, to lower the boom, press and hold the <b>BOOM DOWN</b> button on the remote.</p>`
                
              }
            ]
          },
          {
            id: 'boomrot',
            campos: {
              camera:[-1485.0539836097382, 394.7875247106073, -518.6429115704836],
              controls: [-17.85989274689098, 150, -249.0564813616552]
            },
            conditions: [
              {
                type: 'lock',
                target: 'FreestyleReach',
                progress: 0,
                lock: {
                  ownTarget: 'FreestyleRotate',
                  min: 7,
                  actionDir: -1,
                  max: 100
                }
              }
            ],
            actions: [
              {
                buttons: [
                  {
                    name: 'WhiteBTn3',
                    dir: -1,
                    syncSound: true,
                    sound: './simulations/sounds/sim1and2boom.mp3',
                  },
                  {
                    name: 'WhiteBTn4',
                    dir: 1,
                    syncSound: true,
                    sound: './simulations/sounds/sim1and2boom.mp3',
                  },
                ],
                clipName: 'FreestyleRotate',
                type: 'hold',
                actionspeed: 1 / 6,
              }
            ],
            content: [
              {
                title: 'BOOM ROTATION',
                subtitle: 'LEFT & RIGHT',
                text: 
                  `<p> To rotate the boom, press and hold the highlighted <b> BOOM RIGHT </b> button. Once rotated right, press and hold the <b> BOOM LEFT </b> button to rotate the boom left. </p>`
                
              }
            ]
          },
          {
            id: 'boomreach',
            campos: {
              camera:[-1485.0539836097382, 394.7875247106073, -518.6429115704836],
              controls: [-17.85989274689098, 150, -249.0564813616552]
            },
            actions: [
              {
                buttons: [
                  {
                    name: 'WhiteBTn6',
                    dir: 1,
                    syncSound: true,
                    sound: './simulations/sounds/sim3-extend.mp3',
                  },
                  {
                    name: 'WhiteBtn5',
                    dir: -1,
                    syncSound: true,
                    sound: './simulations/sounds/boom3-back.mp3',
                  },
                ],
                clipName: 'FreestyleReach',
                type: 'hold',
                actionspeed: 1 / 1.8,
              }
            ],
            conditions: [
              {
                type: 'min',
                progress: 5,
                target: 'FreestyleRotate'
              }
            ],
            content: [
              {
                title: 'BOOM REACH',
                subtitle: 'EXTENDING & RETRACTING',
                text: 
                  `<p> To extend the boom, press and hold the highlighted <b>BOOM OUT </b> button. Once extended, press and hold the <b> BOOM IN </b> button. </p>`
                
              }
            ]
          },
          {
            id: 'water',
            campos: {
              camera: [1153.1234337999915, 351.4517123880841, 248.61741083786697],
              controls: [279.91737441114907, 150, -200.02327790206962]
            },
            counter: {
              min: 0,
              max: 2,
              type: 'animationState',
              effects: [
                {
                  state: 1,
                  sound: `./simulations/sounds/sim5and10${audioExt}`,
                },
                {
                  state: 1.333333333,
                  sound: `./simulations/sounds/sim102${audioExt}`,
                },
                {
                  state: 2,
                  sound: `./simulations/sounds/sim103${audioExt}`,
                },
              ]
            },
            actions: [
              {
                buttons: [
                  {
                    name: 'WhiteBTn9',
                    dir: 1,
                  },
                  {
                    name: 'WhiteBTn10',
                    dir: -1,
                  },
                ],
                // name: 'BoomReach',
                type: 'toggle',
                nativeAnimation: {
                  name: 'dynamicWaterNative',
                  meshName: 'Flow_(1)',
                }
              },
              {
                secondary: true,
                type: 'increment',
                buttons: [
                  {
                    name: 'WhiteBTn9',
                    dir: -1,
                  },
                  {
                    name: 'WhiteBTn10',
                    dir: 1,
                  },
                ]
              }
            ],
            content: [
              {
                title: 'WATER',
                subtitle: 'ON & OFF',
                text: `<p> To turn the water on & off, press the highlighted <b>WATER ON & OFF</b> buttons.</p>`,
                tip: 'To simulate all manual actions required by the Water operation, return to the main menu to practice the complete process through the tutorial.'
              },
              {
                title: 'WATER PRESSURE',
                subtitle: 'DECREASE & INCREASE',
                text: `<p>To Increase the water pressure, press the highlighted <b> INCREASE </b> button. To decrease the water pressure, press the <b> DECREASE </b> button.</p>`,
                tip: 'To simulate all manual actions required by the Water Pressure operation, return to the main menu to practice the complete process through the tutorial.'
              },
            ]
          },
          {
            id: 'vacuum',
            campos: {
              camera:[-1485.0539836097382, 394.7875247106073, -518.6429115704836],
              controls: [-17.85989274689098, 150, -249.0564813616552]
            },
            actions: [
              {
                buttons: [
                  {
                    name: 'WhiteBTn7',
                    dir: 1,
                    sound: `./simulations/sounds/sim4vacuum.mp3`,
                  },
                  {
                    name: 'WhiteBTn8',
                    dir: -1,
                  },
                ],
                // name: 'BoomReach',
                type: 'toggle',
                nativeAnimation: {
                  name: 'dynamicVacuum',
                  meshName: 'FreestyleVacuum',
                }
              },
            ],
            content: [
              {
                title: 'VACUUM',
                subtitle: 'ON & OFF',
                text: `<p> To turn the water on & off, press the highlighted <b>WATER ON & OFF</b> buttons.</p>`,
                tip: 'To simulate all manual actions required by the Water operation, return to the main menu to practice the complete process through the tutorial.'
              }
            ]
          },
          
          {
            id: 'engine',
            campos: {
              camera:[-1070.2872995114967, 405.74854866418525, -195.55943408910122],
              controls: [-11.009311166759492, 150, -213.2172535469850]
            },
            counter: {
              min: 0,
              max: 6,
              type: 'graphicState',
              effects: [
                {
                  state: 0,
                  sound: `./simulations/sounds/sim91${audioExt}`,
                },
                {
                  state: 1,
                  sound: `./simulations/sounds/sim92${audioExt}`,
                },
                {
                  state: 2,
                  sound: `./simulations/sounds/sim93${audioExt}`,
                },
                {
                  state: 3,
                  sound: `./simulations/sounds/sim94${audioExt}`,
                },
                {
                  state: 4,
                  sound: `./simulations/sounds/sim95${audioExt}`,
                },
                {
                  state: 5,
                  sound: `./simulations/sounds/sim96${audioExt}`,
                },
                {
                  state: 6,
                  sound: `./simulations/sounds/sim97${audioExt}`,
                },
              ]
            },
            actions: [
              {
                secondary: true,
                type: 'increment',
                buttons: [
                  {
                    name: 'WhiteBTn7',
                    dir: -1,
                  },
                  {
                    name: 'WhiteBTn8',
                    dir: 1,
                  },
                ]
              }
            ],
            content: [
              {
                title: 'ENGINE',
                subtitle: 'RESUME & SET',
                text: `<p> To Increase the engine RPM, press the highlighted <b>ENGINE SET </b> button. To decrease the engine RPM press <b> ENGINE RESUME </b> button. </p>`,
              },
            ]
          },
          {
            id: 'doorlatch',
            campos: {
              camera: [23.604223050008965, 220.85066984055325, -1144.7849977990886],
              controls: [0, 150, 0]
            },
            conditions: [
              {
                // type: 'done',
                progress: 0,
                target: 'FreestyleDoorOpen'
              }
            ],
            actions: [
              {
                secondary: true,
                buttons: [
                  {
                    name: 'WhiteBTn1',
                    dir: 1,
                    syncSound: true,
                    sound: './simulations/sounds/sim6door-lock.mp3',
                  },
                  {
                    name: 'WhiteBTn2',
                    dir: -1,
                    syncSound: true,
                    sound: './simulations/sounds/sim6door-lock.mp3',
                  },
                ],
                clipName: 'FreestyleDoorLatch',
                type: 'toggle',
                actionspeed: 2 ,
              }
            ],
            content: [
              {
                title: 'DOOR LATCH',
                subtitle: 'LOCK & UNLOCK',
                text: `<p> To unlock & lock the door latch, press the highlighted <b>BOOM UNLOCK & LOCK </b> buttons.</p>`,
              },
            ]
          },
          {
            id: 'doorOpen',
            campos: {
              camera: [23.604223050008965, 220.85066984055325, -1144.7849977990886],
              controls: [0, 150, 0]
            },
            conditions: [
              {
                // type: 'done',
                progress: 0,
                target: 'MudSweep'
              },
              {
                // type: 'done',
                progress: 100,
                target: 'FreestyleDoorLatch'
              },
            ],
            actions: [
              {
                secondary: true,
                buttons: [
                  {
                    name: 'WhiteBTn3',
                    dir: 1,
                    syncSound: true,
                    sound: './simulations/sounds/sim7door-opening.mp3',
                  },
                  {
                    name: 'WhiteBTn4',
                    dir: -1,
                    syncSound: true,
                    sound: './simulations/sounds/sim7door-closing.mp3',
                  },
                ],
                clipName: 'FreestyleDoorOpen',
                secondClip: 'FreestyleDoorHydraulic',
                type: 'hold',
                actionspeed: 1 / 3.5,
              }
            ],
            content: [
              {
                title: 'DOOR',
                subtitle: 'OPEN & CLOSE',
                text: `<p> To open & close the door, press the highlighted <b> DOOR OPEN & CLOSE </b> buttons. </p>`,
              },
            ]
          },
          {
            id: 'mudSweep',
            campos: {
              camera: [23.604223050008965, 220.85066984055325, -1144.7849977990886],
              controls: [0, 150, 0]
            },
            conditions: [
              {
                // type: 'done',
                progress: 100,
                target: 'FreestyleDoorOpen'
              }
            ],
            actions: [
              {
                secondary: true,
                buttons: [
                  {
                    name: 'WhiteBtn5',
                    dir: -1,
                    syncSound: true,
                    sound: './simulations/sounds/sim8mud.mp3',
                  },
                  {
                    name: 'WhiteBTn6',
                    dir: 1,
                    syncSound: true,
                    sound: './simulations/sounds/sim8mud.mp3',
                  },
                ],
                clipName: 'MudSweep',
                type: 'hold',
                actionspeed: 1 / 7,
              }
            ],
            content: [
              {
                title: 'MUD SWEEP',
                subtitle: 'IN & OUT',
                text: `<p> To extend or retract the mud sweep, press the highlighted <b> MUD SWEEP IN & OUT </b> buttons. </p>`,
              },
            ]
          },
        ], 
      }
      
    },
  ],
  
  tips: [
      {
          name: 'controls',
          text: {
              REMOTE_SIMULATION: 'Switch to manual controls by selecting the remote icon',
              MANUAL_SIMULATION: 'Switch to manual controls by selecting the manual icon',
          }
      }
  ],
  copyright: 'CREATED BY MIND-BLOWN.CA'
}